import React from 'react';
import { Button } from 'antd';
import { toast, ToastBar, Toaster } from 'react-hot-toast';
import { toastDismissed } from 'vl-common/src/lib/toastUtils';

export const DismissibleToast = () => (
  <div>
    <Toaster
      reverseOrder={false}
      position="top-center"
      toastOptions={{
        style: {
          borderRadius: '8px',
          background: '#333',
          color: '#fff',
          maxWidth: '90vw'
        }
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => {
            console.log(message);
            return (
              <Button
                data-testid="dismiss-toast-button"
                type="link"
                style={{ display: 'flex', flexDirection: 'row' }}
                onClick={() => {
                  if (t.type !== 'loading') {
                    toast.dismiss(t.id);
                    toastDismissed(t);
                  }
                }}
              >
                {icon}
                {message}
              </Button>
            );
          }}
        </ToastBar>
      )}
    </Toaster>
  </div>
);
